import {
  REMOVE_ANSWER,
  REMOVE_ANSWER_SUCCESS,
  REMOVE_ANSWER_CLEAN,
  REMOVE_ANSWER_ERROR,
} from "./actionTypes"

export const removeAnswer = idQuestionAnswer => ({
  type: REMOVE_ANSWER,
  payload: { idQuestionAnswer },
})

export const removeAnswerSuccess = answer => {
  return {
    type: REMOVE_ANSWER_SUCCESS,
    payload: { answer },
  }
}

export const removeAnswerClean = () => {
  return {
    type: REMOVE_ANSWER_CLEAN,
    payload: {},
  }
}

export const removeAnswerError = error => {
  return {
    type: REMOVE_ANSWER_ERROR,
    payload: error,
  }
}
